"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSTANTS = void 0;
const CONSTANTS = exports.CONSTANTS = {
  USERS: 'USERS',
  STATUS: 'STATUS',
  APP_NAME: 'APP NAME / ROLE',
  ROLE: 'ROLE',
  LAST_LOG_IN: 'Last Log-In',
  REMOVE_ACCESS: 'Remove Access',
  VIEW_USERS_DNAME: 'displayName',
  VIEW_USERS_STATUS: 'status',
  VIEW_USERS_ROLE: 'appRoleName'
};